import React from 'react';
import SubscriptionStatusBadge from './SubscriptionStatusBadge';

// Subscription status for one row of the members list.
// Members with no live subscription are shown as "No subscription" with two ways to fix it:
//   - Send sign up link: emails them a fresh link back to the start of their invitation
//   - Link in GoCardless: the manual page for linking them to a subscription that already exists
// Admins are not expected to have a subscription, so nothing is shown for them.
const MemberSubscriptionCell = ({ user, onSendLink, onLinkGoCardless }) => {
    if (user.isAdmin) {
        return <span className="text-xs text-emerald-600/50">Not needed</span>;
    }

    if (user.hasSubscription) {
        return <SubscriptionStatusBadge user={user} />;
    }

    // Stop the click reaching the row, which would tick the member's checkbox
    const handle = (action) => (e) => {
        e.stopPropagation();
        action(user);
    };

    return (
        <div className="flex flex-col items-start gap-2">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-900/30 text-amber-300 border border-amber-700/40">
                No subscription
            </span>
            <div className="flex flex-wrap gap-2">
                <button
                    type="button"
                    onClick={handle(onSendLink)}
                    className="px-2.5 py-1 text-xs font-semibold rounded-lg bg-emerald-600/20 text-emerald-300 border border-emerald-600/30 hover:bg-emerald-600/30 transition-colors"
                    title="Email them a fresh link back to the start of their invitation"
                >
                    Send sign up link
                </button>
                <button
                    type="button"
                    onClick={handle(onLinkGoCardless)}
                    className="px-2.5 py-1 text-xs font-semibold rounded-lg bg-blue-900/20 text-blue-300 border border-blue-700/30 hover:bg-blue-900/40 transition-colors"
                    title="They already pay through GoCardless. Link them to that subscription."
                >
                    Link in GoCardless
                </button>
            </div>
        </div>
    );
};

export default MemberSubscriptionCell;
